export const platformId = 'android'
export const isSafari = false
